export enum EAccountSyncStatus {
  START,
  IN_PROCESS,
  COMPLETE,
}
